import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { translate, Trans } from "react-i18next";
import { withRouter } from "react-router";

import FormNextAppointment from "containers/FormNextAppointment";
import { getAppointments } from "actions/appointments";

import Wrapper from "components/Wrapper";
import Title from "components/Title";
import Modal from "components/Modal";
import Table from "components/Table";
import Loader from "components/Loader";

import consts from "consts/consts";

import rootStyle from "../../style.css";

@translate()
@withRouter
@connect((state) => ({
  weCareID: state.session.weCareID,
  userAppointments: state.appointments.user,
}))
export default class PageAppointments extends Component {
  state = {
    isModalOpened: false,
    selectedDay: undefined,
    selectedAppointmentId: undefined,
  };

  componentDidMount() {
    const isUserIdentified = this.props.weCareID;
    if (!isUserIdentified) {
      this.props.history.replace("/");
    }

    let langCheck = setInterval(function() {
      let lngs = document.querySelectorAll('.b2c-global-header-language-menu li a');
      Array.prototype.forEach.call(lngs, function (lng) {
        let oldhref = lng.href;
        let href = lng.href.split('/');
        if (href[href.length-1].indexOf('lng') !== -1) {
            href = href[href.length-1].split('=');
        }
        let lang = href[href.length-1];
        lng.href = document.location.protocol + '//' + document.location.host + document.location.pathname + '?lng=' + lang;
        if (oldhref === lng.href) {
            clearInterval(langCheck);
        }
      });
    }, 300);
  }

  onOpenModalClick(appointment) {
    this.setState({
      isModalOpened: true,
      selectedAppointment: appointment,
    });
  }

  onCloseModal() {
    if (document.getElementById('confirmationModal')) {
      this.props.dispatch(getAppointments(this.props.weCareID)).then(response => {});
    }

    this.setState({
      isModalOpened: false,
      selectedAppointment: undefined,
    });
  }

  orangeRender(userAppointments) {
    return (
      <Fragment>
        <Wrapper>
          <Title><Trans>_APPOINTMENT_INDEX_TITLE</Trans></Title>
          <p><Trans>_APPOINTMENT_WELCOME</Trans></p>
          <p><Trans>_APPOINTMENT_INFOS_REPLAN_DATE</Trans></p>
          {userAppointments.loading && <Loader />}
          {!userAppointments.loading && (
            <Table appointments={userAppointments.data} modifyCallback={this.onOpenModalClick.bind(this)} />
          )}
        </Wrapper>
        <Modal isOpened={this.state.isModalOpened} onClose={this.onCloseModal.bind(this)}>
          <FormNextAppointment appointment={this.state.selectedAppointment} closeModal={this.onCloseModal.bind(this)} />
        </Modal>
      </Fragment>
    );
  }

  heyRender(userAppointments) {
    return (
      <Fragment>
        <Wrapper>
          <div className={rootStyle.fontWeightBold}>
            <Title rootClassname={rootStyle.mb4}><Trans>_HEY_APPOINTMENT_INDEX_TITLE</Trans></Title>
            <p><Trans>_HEY_APPOINTMENT_INFOS_RETRIEVE_DATE</Trans></p>
            <p><Trans>_HEY_APPOINTMENT_INFOS_REPLAN_DATE</Trans></p>
            {userAppointments.loading && <Loader />}
            {!userAppointments.loading && (
              <Table customClassRowItemLink={rootStyle.textDecorationNone} appointments={userAppointments.data} modifyCallback={this.onOpenModalClick.bind(this)} />
            )}
          </div>
        </Wrapper>
        <Modal isOpened={this.state.isModalOpened} onClose={this.onCloseModal.bind(this)}>
          <FormNextAppointment appointment={this.state.selectedAppointment} closeModal={this.onCloseModal.bind(this)} />
        </Modal>
      </Fragment>
    );
  }

  renderSwitch() {
    const { userAppointments } = this.props;
    switch (process.env.APP_MODE) {
      case consts.mode.heyfix: return this.heyRender(userAppointments);
      default: return this.orangeRender(userAppointments);
    }
  }

  render() {
    return this.renderSwitch();
  }
}



// WEBPACK FOOTER //
// ./src/containers/PageAppointments/index.js